function setFloatSaleDataRows(data) {
  const floatSaleData = data.details
  
  if (floatSaleData === null || floatSaleData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".float-sales-data").empty()

  let totalAmount = 0

  // set data rows
  $.each(floatSaleData, function (key, datum) {
    const floatSaleDetails = datum
    const bankName = floatSaleDetails.account_name
    const amount = floatSaleDetails.amount
    const details = floatSaleDetails.details
    const elementId = `${key}${floatSaleDetails.account_id}`
    totalAmount += parseFloat(amount)

    $(".float-sales-data").append(
      `<tr data-key=${key} id='${elementId}'>
        <td class="bank-name" >${bankName}</td>
        <td class="bank-name" >${details}</td>
        <td class="amount text-right">${numberWithCommas(amount)}</td>
      </tr>`
    )
  })

  totalAmount = numberWithCommas(totalAmount)

  // set total row
  $(".float-sales-data").append(
    `<tr id='floatSale-total'>
      <td><strong>TOTAL</strong></td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${totalAmount}</strong>
      </td>
    </tr>`)
}

function setBankDetails(view = 'edit', floatSaleIdAttr) {
  let floatSaleId = $('#float-sale-form input[name="revenue[floatSale_id]"').val()

  if (view === 'index') {
    floatSaleId = floatSaleIdAttr
  }
  const action = $('#float-sale-form input[name="revenue[floatSale_action]"').val()

  if (view === 'edit' && (action === 'create' || floatSaleId === null || floatSaleId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/float_sale_details/${floatSaleId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      setFloatSaleDataRows(data)
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });
}


function submitFloatSale() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const createdAt = $('#float-sale-form input[name="revenue[created_at]"]').val()
    const amount = removeCommas($('#float-sale-form input[name="revenue[amount]"]').val())

    $('#float-sale-form input[name="commit"]').prop("disabled", false)

    if (isEmpty(createdAt)) {
      errorString.push(' Sale date cannot be blank');
    }

    if (isNaN(amount) || allWhiteSpaces(amount) || parseFloat(amount) === 0) {
      errorString.push('Amount is not valid');
    }

    const paymentOptions = getPaymentOptionsStorage()

    if (paymentOptions === null ||
      paymentOptions === undefined ||
      (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
      errorString.push('Payment option amount not set')
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#float-sale-form').attr('action')
      const redirectUrl = '/float_sales'
      const branchId = $('#float-sale-form input[name="revenue[branch_id]"]').val()
      const agentId = $('#agent-dropdown option:selected').val()
      const agentCustomerName = $('#float-sale-form input[name="revenue[agent_customer_name]"]').val()
      const tillNumber = $('#float-sale-form input[name="revenue[till_number]"]').val()
      const floatSaleSourceId = $(`select[name="revenue[float_sale_source_id]"] option:selected`).val()
      const description = $('#float-sale-form textarea[name="revenue[description]"]').val()

      let action = "post"

      if ($('#float-sale-form input[name="revenue[sale_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          revenue: {
            branch_id: branchId,
            agent_customer_name: agentCustomerName,
            till_number: tillNumber,
            agent_id: agentId,
            amount: amount,
            created_at: createdAt,
            float_sale_source_id: floatSaleSourceId,
            description: description
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(redirectUrl)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

$(document).ready(function () {
  if ($('#float-sale-form').length > 0) {

    if ($('.amount-div').length > 0) {
      checkAmount('.amount', '.amount-div');
    }

    const initialAgentIdValue =  parseInt($('#agent-dropdown option:selected').val())

    if (initialAgentIdValue === 0){
      $('.float-sale-non-agent').show()
    }else(
      $('.float-sale-non-agent').hide()
    )

    $('#agent-dropdown').change(function(){
      const currenAgentIdValue =  parseInt($('#agent-dropdown option:selected').val())
      if (currenAgentIdValue === 0){
        $('.float-sale-non-agent').show()
      }else(
        $('.float-sale-non-agent').hide()
      )
    })


    submitFloatSale()
    clearFailedSubmit('#float-sale-form')
  }

  $('.view-float-sale-details').click(function () {
    const floatSaleId = $(this).data('float-sale-id')
    setBankDetails('index', floatSaleId)
  })

});
